import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import MaterialIcon from 'shared-library/dist/components/material-icon';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    height: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    boxShadow: '0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)',
    backgroundColor: theme.palette.common.white,
  },
  errorRoot: {
    border: `solid 1px ${theme.palette.error[theme.palette.type]}`,
  },
  warningRoot: {
    border: `solid 1px ${theme.palette.warning[theme.palette.type]}`,
  },
  prefix: {
    width: theme.spacing(1),
    height: '100%',
    borderRadius: theme.spacing(0.5),
  },
  errorPrefix: {
    backgroundColor: theme.palette.error[theme.palette.type],
  },
  warningPrefix: {
    backgroundColor: theme.palette.warning[theme.palette.type],
  },
  icon: {
    paddingLeft: theme.spacing(1),
  },
  message: {
    maxWidth: '50vw',
    padding: '0 10px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  errorMessage: {
    color: theme.palette.error[theme.palette.type],
  },
  warningMessage: {
    color: theme.palette.warning[theme.palette.type],
  },
  action: {
    paddingRight: 0,
  },
}));

const NotificationItem = forwardRef(({
  id,
  message,
  variant,
  action: Action,
}, ref) => {
  const styles = useStyles();

  let icon = variant;
  switch (variant) {
    case 'error':
      icon = 'info';
      break;
    case 'warning':
      icon = 'warning';
      break;
    case 'success':
      icon = 'check_circle';
      break;
    default:
      break;
  }

  return (
    <span ref={ref} className={classNames(styles.root, styles[`${variant}Root`])} id={id}>
      <span className={classNames(styles.prefix, styles[`${variant}Prefix`])} />
      <MaterialIcon
        icon={icon}
        color={variant}
        className={styles.icon}
      />
      <Typography
        classes={{
          root: styles.message,
        }}
        component="span"
        variant="body2"
        className={styles[`${variant}Message`]}
      >
        {message}
      </Typography>
      {Action && (
        <Action
          id={id}
          variant={variant}
          className={styles.action}
        />
      )}
    </span>
  );
});

NotificationItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  action: PropTypes.func,
};

NotificationItem.defaultProps = {
  action: undefined,
};

export default NotificationItem;
